import React from 'react'
import { TableRow, TableHeaderCell, TableHeader, TableCell, TableBody, Table, Label, Header, Grid, Segment, Container } from "semantic-ui-react";
import {connect} from "react-redux";
import {socket} from "../../../lib/socketio";

import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setCurrentPLC } from '../../../actions/headerActions';

const ShortcutGuide = ({addHeader}) => {

    const location = useLocation();
    const currentPLC = useSelector(state => state.header.currentPLC);
    const dispatch = useDispatch();

    React.useEffect(()=> {
        dispatch(setCurrentPLC(location.pathname.slice(-4)));
    },[]);

    const headers = [
        'Shortcut Key',
        'Description'
    ]

    const functionKeys = [
        { key: 'F1', desc: 'Open Sidebar' },
        { key: 'F2', desc: 'Calculated Parameters' },
        { key: 'F3', desc: 'PCS Overview' },
        { key: 'F4', desc: 'Digital I/O Override' },
        { key: 'F5', desc: 'Analog I/O Override' },
        { key: 'F6', desc: 'PP Operations' },
        { key: 'F7', desc: 'Event History' },
        { key: 'F8 (MAIN)', desc: 'SVM IO' },
        { key: 'F8 (PSM)', desc: 'PSM Overview' },
        { key: 'F9 (MAIN)', desc: 'PSM IO' },
        { key: 'F9 (PSM)', desc: 'Stack Overview' },
        { key: 'F10', desc: 'VSD Feedback' },
        { key: 'F11', desc: 'Interlocks' },
        { key: 'F12', desc: 'Sequence Override' },
        { key: '->', desc: 'Go Forward' },
        { key: '<-', desc: 'Go Back' },
        { key: 'Home', desc: 'Plant Overview' }, // update 260316, remove Ctrl + 0 Shortcut (move to Plant Overview Page) as requested
    ]

    const ctrlKeys = [

        { key: 'Ctrl + `', desc: 'PP Operations : MAIN' },
        { key: 'Ctrl + 1', desc: 'PP Operations : PSM1' },
        { key: 'Ctrl + 2', desc: 'PP Operations : PSM2' },
        { key: 'Ctrl + 3', desc: 'PP Operations : PSM3' },
        { key: 'Ctrl + 4', desc: 'PP Operations : PSM4' },
        { key: 'Ctrl + 5', desc: 'PP Operations : PSM5' },
        { key: 'Ctrl + Q', desc: 'Plant Overview' },
    ]

    const altKeys = [
        { key: 'Alt + 1', desc: 'AOGR Flow' },
        { key: 'Alt + 2', desc: 'Current Limiting Device' },
        { key: 'Alt + 3', desc: 'Dispatch' },
        { key: 'Alt + 4', desc: 'Process Air Flow' },
        { key: 'Alt + 5', desc: 'Fuel Flow' },
        { key: 'Alt + 6', desc: 'Start Burner Flow' },
        { key: 'Alt + 7', desc: 'AOGR Blower' },
        { key: 'Alt + 8', desc: 'Cabinet Temp' },
        { key: 'Alt + 9', desc: 'Cathode Anode Purge' },
        { key: 'Alt + 0', desc: 'Reformer Temp' },
        { key: 'Alt + -', desc: 'Stack Fuel' },
        { key: 'Alt + q', desc: 'Model Activation' }
    ]

    const ShortcutRow = ({ shortcut, labelColor }) => (
        <TableRow style={{ backgroundColor: '#2a2a2a', color: '#f0f6fc' }}>
            <TableCell style={{ backgroundColor: '#2a2a2a', color: '#f0f6fc', borderColor: '#444', width : '40%'}}>
                <Label
                    className="monospace-label"
                    style={{
                        fontWeight: 'bold',
                        backgroundColor: labelColor,
                        color: 'white',
                        border: 'none'
                    }}
                >
                    {shortcut.key}
                </Label>
            </TableCell>
            <TableCell style={{ backgroundColor: '#2a2a2a', color: '#f0f6fc', borderColor: '#444', fontFamily : 'Roboto' }}>
                {shortcut.desc}
            </TableCell>
        </TableRow>
    )

    const ShortcutTable = ({ data, title, headerColor, labelColor }) => (
        <Segment style={{ backgroundColor: '#1a1a1a', border: '1px solid #444', height: '100%'}}>
            <Header
                as="h3"
                textAlign="center"
                style={{ color: '#eeeeee', marginBottom: '1rem', fontFamily : 'Roboto'}}
            >
                {title}
            </Header>
            <Table
                celled
                striped
                hover
                compact
                style={{ backgroundColor: '#2a2a2a', border: '1px solid #444' }}
            >
                <TableHeader>
                    <TableRow>
                        {headers.map((header) => (
                            <TableHeaderCell
                                key={header}
                                style={{
                                    backgroundColor: headerColor,
                                    color: 'white',
                                    borderColor: '#666',
                                    fontWeight : 'bold',
                                    fontFamily : 'Roboto'
                                }}
                            >
                                {header}
                            </TableHeaderCell>
                        ))}
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {data.map((shortcut, idx) => (
                        <ShortcutRow key={idx} shortcut={shortcut} labelColor={labelColor} />
                    ))}
                </TableBody>
            </Table>
        </Segment>
    )

    return (
        <div style={{ minHeight: '100vh', padding: '2rem' }}>
            <Container fluid>
                <Header
                    as="h1"
                    textAlign="center"
                    style={{
                        color: '#ffffff',
                        marginBottom: '3rem',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
                    }}
                >
                    Keyboard Shortcuts Guide
                </Header>

                {/* 가로로 3개 테이블 배치 */}
                <Grid columns={3} stackable >
                    <Grid.Column>
                        <ShortcutTable
                            data={functionKeys}
                            title="Function Keys"
                            headerColor='#434447'
                            labelColor='#6b7080 '
                        />
                    </Grid.Column>

                    <Grid.Column>
                        <ShortcutTable
                            data={ctrlKeys}
                            title="Ctrl Combinations"
                            headerColor='#434447'
                            labelColor='#6b7080'
                        />
                    </Grid.Column>

                    <Grid.Column>
                        <ShortcutTable
                            data={altKeys}
                            title="Alt Combinations"
                            headerColor="#434447"
                            labelColor="#6b7080"
                        />
                    </Grid.Column>
                </Grid>
            </Container>
        </div>
    )
};

const styles = {
    label: {
        float: 'right',
        textAlign: 'center'
    },
    toggle: {
        marginLeft: '8px'
    },
    div: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    header: {
        marginBottom: '20px'
    }
};

export default ShortcutGuide;